import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const UserInfo = () => {
  const [profile, setProfile] = useState({
    fullName: "",
    email: "",
    gender: "",
  });
  const [selectedGender, setSelectedGender] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const handleGenderChange = (gender) => {
    setSelectedGender(gender);
    setProfile((prevProfile) => ({
      ...prevProfile,
      gender: gender,
    }));
    setErrors({ ...errors, gender: "" }); // Clear gender error if selected
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setProfile((prevProfile) => ({
      ...prevProfile,
      [name]: value,
    }));
    setErrors({ ...errors, [name]: "" }); // Clear field-specific error on change
  };

  const validateForm = () => {
    const errors = {};
    if (!profile.fullName.trim()) {
      errors.fullName = "Full Name is required";
    }
    if (!profile.email.trim()) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(profile.email)) {
      errors.email = "Email is incorrect";
    }
    if (!selectedGender) {
      errors.gender = "Please select a gender";
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSave = async () => {
    if (validateForm()) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_URL}/user/signup`,
          profile
        );
        const token = response.data.token;
        localStorage.setItem("STITCHD_ID", token);
        navigate("/");
        window.location.reload();
      } catch (error) {
        console.error("Error saving profile:", error);
        // Handle error (e.g., show error message)
      }
    }
  };

  return (
    <div className="p-6 max-w-xl md:mx-auto border bg-white rounded-lg shadow-md mt-10 font-sans mx-2">
      <p className="text-center text-red-500 font-medium text-3xl mb-6">
        Hey, you're almost there!
      </p>
      <div className="">
        <div className="flex flex-col mb-8 w-full ">
          <label className="font-medium mb-1 text-gray-600 text-xl">
            Full Name
          </label>
          <input
            type="text"
            name="fullName"
            value={profile.fullName}
            onChange={handleChange}
            className={`border p-2 rounded ${
              errors.fullName ? "border-red-500" : ""
            }`}
          />
          {errors.fullName && (
            <p className="text-red-500 text-sm mt-1">{errors.fullName}</p>
          )}
        </div>

        <div className="flex flex-col mb-8 w-full">
          <label className="font-medium mb-1 text-gray-600 text-xl">
            Email
          </label>
          <input
            type="text"
            name="email"
            value={profile.email}
            onChange={handleChange}
            className={`border p-2 rounded ${
              errors.email ? "border-red-500" : ""
            }`}
          />
          {errors.email && (
            <p className="text-red-500 text-sm mt-1">{errors.email}</p>
          )}
        </div>

        <div className="flex flex-col mb-8">
          <label className="font-medium mb-1 text-gray-600 text-xl">
            Gender
          </label>
          <div className="flex items-center space-x-4">
            <button
              className={`border p-2 rounded text-xl w-24 hover:bg-red-400 ${
                selectedGender === "Male"
                  ? "bg-red-500 text-white"
                  : "bg-gray-200 text-gray-600"
              }`}
              onClick={() => handleGenderChange("Male")}
            >
              Male
            </button>
            <button
              className={`border p-2 rounded text-xl w-24 hover:bg-red-400 ${
                selectedGender === "Female"
                  ? "bg-red-500 text-white"
                  : "bg-gray-200 text-gray-600"
              }`}
              onClick={() => handleGenderChange("Female")}
            >
              Female
            </button>
            <button
              className={`border p-2 rounded text-xl w-24 hover:bg-red-400 ${
                selectedGender === "Other"
                  ? "bg-red-500 text-white"
                  : "bg-gray-200 text-gray-600"
              }`}
              onClick={() => handleGenderChange("Other")}
            >
              Other
            </button>
          </div>
          {errors.gender && (
            <p className="text-red-500 text-sm mt-1">{errors.gender}</p>
          )}
        </div>

        <div className="flex justify-end space-x-2">
          <button
            onClick={handleSave}
            className="bg-red-500 text-white px-4 py-2 rounded shadow hover:bg-red-600 text-xl hover:shadow-lg"
          >
            Continue
          </button>
          {/* <button
            onClick={handleCancel}
            className="bg-white border text-red-500 px-4 py-2 rounded shadow hover:text-gray-600"
          >
            Cancel
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default UserInfo;
